import { ApiContext } from '../../types'
import { User } from '@/api_client/types/user'
import { deserializeUser } from '../serializers/user'
import firebase from 'firebase/compat'
import UserInfo = firebase.UserInfo
import setPreferredCloudStorage from '@/api_client/api/setPreferredCloudStorage'

export default async function logIn(
  { client, config }: ApiContext,
  firebaseUid,
  firebaseToken,
  provider: UserInfo = null,
  display_language = null,
): Promise<User> {
  // set preferred cloud storage
  await setPreferredCloudStorage()

  const data = {
    firebase_token: firebaseToken,
    firebase_uid: firebaseUid,
    username: firebaseUid,
    name: firebaseUid,
    is_anonymous: true,
    default_cloud_storage_region:
      localStorage.getItem('default_cloud_storage_region') ?? 'soundtype-us',
    country: localStorage.getItem('country') ?? '',
    continent_code: localStorage.getItem('continent_code') ?? '',
    country_code: localStorage.getItem('country_code') ?? '',
  }

  // var isAnonymous = true;
  if (provider != null) {
    data['is_anonymous'] = false
    data['provider'] = {
      uid: provider.uid,
      email: provider.email,
      display_name: provider.displayName,
      photo_url: provider.photoURL,
      phone_number: provider.phoneNumber,
      provider_id: provider.providerId,
    }
  }

  if (display_language != null) {
    data['display_language'] = display_language
  }

  const response = await client.users.login(data)

  if (response.isSuccess()) {
    const payload = response.success()
    return deserializeUser(payload)
  } else {
    console.log('logIn- fail')
    console.log(response.fail())
    throw response.fail()
  }
}
